import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '@environments/environment';

//import { AuthService } from '@shared/services/guards/auth.service';

export class HttpProviderService {

 // tokenSample: any;
  constructor(private http: HttpClient, private providerPath: string, /*private _authService: AuthService*/) {
   
  }
  
 
  sendGetRequest(path: string, headers: HttpHeaders, params: HttpParams) {
  
    //headers.append('Authorization', localStorage.getItem('token'))
    //headers.append('x-api-key', 'Whi9QqIyLnasPChPwRqgFKdRdpUslxJ54MK72VZ0')
    //headers.append('Access-Control-Allow-Origin', '*')
    //headers.append('Access-Control-Allow-Headers', '*')
    //headers.append('Access-Control-Allow-Methods', '*')
    //headers.append('accept', 'application/pdf')

    const requestOptions = {

      headers: headers.append('x-api-key', 'Whi9QqIyLnasPChPwRqgFKdRdpUslxJ54MK72VZ0') ,//headers.append('Authorization', JSON.stringify(localStorage.getItem('token'))),
      params: params,
      observe: "response" as 'body',
      
    };

    return this.http.get(`${this.providerPath}${path}`, requestOptions);
  }
 
  sendGetCustRequest(path: string, headers: HttpHeaders, params: HttpParams) {
    //headers.append('Authorization', localStorage.getItem('token'))
    //headers.append('x-api-key', 'Whi9QqIyLnasPChPwRqgFKdRdpUslxJ54MK72VZ0')
    //headers.append('Access-Control-Allow-Origin', '*')
    //headers.append('Access-Control-Allow-Headers', '*')
    //headers.append('Access-Control-Allow-Methods', '*')
    //headers.append('accept', 'application/pdf')

    const requestOptions = {

      headers: headers.append('x-api-key', 'Whi9QqIyLnasPChPwRqgFKdRdpUslxJ54MK72VZ0'),//headers.append('Authorization', JSON.stringify(localStorage.getItem('token'))),
      params: params,
      observe: "response" as 'body',
      
    };

    return this.http.get(`${this.providerPath}${path}`, requestOptions);
  }

  sendPostRequest(path: string, body: any, headers: HttpHeaders, params: HttpParams) {
    //headers.append('Authorization', localStorage.getItem('token'))
    //headers.append('x-api-key', 'ISBNUmi5ksDjl2fuznjTpaar8L8hAoawLCGzws70')
    //headers.append('Access-Control-Allow-Origin', '*')
    //headers.append('Access-Control-Allow-Headers', '*')
    //headers.append('Access-Control-Allow-Methods', '*')
    
    

    const requestOptions = {
      headers: headers.append('x-api-key', 'ISBNUmi5ksDjl2fuznjTpaar8L8hAoawLCGzws70'),
      observe: "response" as 'body',
      params: params
    };
    return this.http.post(`${this.providerPath}${path}`, body, requestOptions);
  }

  sendPatchRequest(path: string, body: any, headers: HttpHeaders, params: HttpParams) {
    //headers.append('Authorization', localStorage.getItem('token'))
    //headers.append('x-api-key', 'Whi9QqIyLnasPChPwRqgFKdRdpUslxJ54MK72VZ0')
    //headers.append('Access-Control-Allow-Origin', '*')
    //headers.append('Access-Control-Allow-Headers', '*')
    //headers.append('Access-Control-Allow-Methods', '*')

    const requestOptions = {
      headers: headers.append('x-api-key', 'ISBNUmi5ksDjl2fuznjTpaar8L8hAoawLCGzws70'),
      observe: "response" as 'body',
      params: params
    };
    return this.http.patch(`${this.providerPath}${path}`, body, requestOptions);
  }

  sendPutRequest(path: string, body: any, headers: HttpHeaders, params: HttpParams) {
    //headers.append('Authorization', localStorage.getItem('token'))
    //headers.append('x-api-key', 'Whi9QqIyLnasPChPwRqgFKdRdpUslxJ54MK72VZ0')
    //headers.append('Access-Control-Allow-Origin', '*')
    //headers.append('Access-Control-Allow-Headers', '*')
    //headers.append('Access-Control-Allow-Methods', '*')
    
    const requestOptions = {
      headers: headers.append('x-api-key', 'ISBNUmi5ksDjl2fuznjTpaar8L8hAoawLCGzws70'),
      observe: "response" as 'body',
      params: params
    };
    return this.http.put(`${this.providerPath}${path}`, body, requestOptions);
  }

  sendDeleteRequest(path: string, headers: HttpHeaders, params: HttpParams) {
    //headers.append('Authorization', localStorage.getItem('token'))
    //headers.append('x-api-key', 'Whi9QqIyLnasPChPwRqgFKdRdpUslxJ54MK72VZ0')
    //headers.append('Access-Control-Allow-Origin', '*')
    //headers.append('Access-Control-Allow-Headers', '*')
    //headers.append('Access-Control-Allow-Methods', '*')

    const requestOptions = {
      headers: headers.append('x-api-key', 'ISBNUmi5ksDjl2fuznjTpaar8L8hAoawLCGzws70'),
      observe: "response" as 'body',
      params: params
    };
    return this.http.delete(`${this.providerPath}${path}`, requestOptions);
  }

}

@Injectable({
  providedIn: 'root'
})
export class MemberProviderService extends HttpProviderService {
  constructor(private providerHttp: HttpClient) {
    super(providerHttp, "");
  }
}

@Injectable({
  providedIn: 'root'
})
export class AdminProviderService extends HttpProviderService {
  constructor(private providerHttp: HttpClient) {
    super(providerHttp, environment.hostURL+ '/admin'); 
    //'/dev');//'/admin');-BAM EDIT
  }
}

@Injectable({
  providedIn: 'root'
})
export class ContractorProviderService extends HttpProviderService {
  constructor(private providerHttp: HttpClient) {
    super(providerHttp, environment.hostURL+'/contractor');
  }
}

@Injectable({
  providedIn: 'root'
})
export class ReferenceDataProviderService extends HttpProviderService {
  constructor(private providerHttp: HttpClient) {
    super(providerHttp, environment.hostURL+'/reference');
  }
}

/*@Injectable({
  providedIn: 'root'
})
export class CustReqProviderService extends HttpProviderService {
  constructor(private providerHttp: HttpClient) {
    super(providerHttp, environment.hostURL+'/request');
  }
}*/

@Injectable({
  providedIn: 'root'
})
export class RequestProviderService extends HttpProviderService {
  constructor(private providerHttp: HttpClient) {
    super(providerHttp, environment.hostURL+'/request');
  }
}
@Injectable({
  providedIn: 'root'
})
export class UploadProviderService extends HttpProviderService {
  constructor(private providerHttp: HttpClient) {
    super(providerHttp, environment.hostURL+'/document');
  }
}